<div class="header">
  <h2 *ngIf="this.type==='remember'" mat-dialog-title>{{'core.signin.rememberPassword' | translate}}</h2>
  <h3 *ngIf="this.type==='remember'"> {{'core.signin.rememberPasswordText' | translate}}</h3>

  <h2 *ngIf="this.type==='link'" mat-dialog-title>{{'core.signin.linkAccess' | translate}}</h2>
  <h3 *ngIf="this.type==='link'"> {{'core.signin.linkAccessText' | translate}}</h3>

</div>

<form [formGroup]="form" (submit)="rememberPass();">

  <mat-dialog-content>
    <mat-form-field class="login-field">
      <!-- <mat-label>{{'core.signin.username' | translate}}</mat-label> -->
      <span matPrefix>
        <mat-icon svgIcon="user"></mat-icon>
      </span>
      <input matInput placeholder="{{'core.signin.username' | translate}}" formControlName="username">
      <mat-error>{{'general.required' | translate}}</mat-error>
    </mat-form-field>
    <mat-form-field class="login-field">
      <!-- <mat-label>{{'core.signin.email' | translate}}</mat-label> -->
      <span matPrefix>
        <mat-icon svgIcon="mail"></mat-icon>
      </span>
      <input matInput placeholder="{{'core.signin.email' | translate}}" formControlName="email">
      <mat-error>{{'general.required' | translate}}</mat-error>
    </mat-form-field>
    <h3>Contacto: <a hrf='tel:915211825'>91 521 18 25</a></h3>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button color="accent">{{'general.send' | translate}}</button>
  </mat-dialog-actions>
</form>
